import type { SVGProps } from 'react'
const SvgSyNews = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M5 10c0-1.87 0-2.804.402-3.5A3 3 0 0 1 6.5 5.402C7.196 5 8.13 5 10 5h4c1.87 0 2.804 0 3.5.402A3 3 0 0 1 18.598 6.5C19 7.196 19 8.13 19 10z"
		/>
		<path d="M8 4.4A3.605 3.605 0 0 0 4.4 8v8c0 1.984 1.616 3.6 3.6 3.6h8c1.984 0 3.6-1.616 3.6-3.6V8c0-1.984-1.616-3.6-3.6-3.6zm0 1.2h8c1.34 0 2.4 1.06 2.4 2.4v8c0 1.34-1.06 2.4-2.4 2.4H8c-1.34 0-2.4-1.06-2.4-2.4V8c0-1.34 1.06-2.4 2.4-2.4" />
		<path d="M5 9.4a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h14a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6z" />
	</svg>
)
export default SvgSyNews
